import React, { useEffect, useState } from "react";
import "./TeamSection.css";
import axios from "axios";

export default function TeamSection() {
  const [teamMembers, setTeamMembers] = useState([]);

  const API_URL = "https://admin.cmgroupofcompanies.com";

  useEffect(() => {
  const fetchTeam = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/team-images.php`);
      setTeamMembers(res.data);
    } catch (error) {
      console.error("Error fetching team:", error);
    }
  };

  fetchTeam();
}, []);


  return (
    <section className="teamPro-container">
      <div className="teamPro-header">
        <h2 className="teamPro-title">Meet With Professional Team</h2>
        <p className="teamPro-desc">
          Our professional team brings together years of industry experience,
          technical know-how, and creative vision to provide seamless print,
          signage, and delivery solutions.
        </p>
      </div>

      {/* GRID */}
      <div className="teamPro-grid">
        {teamMembers.map((member) => (
          <div key={member.id} className="teamPro-card">
            <div className="teamPro-imageWrapper">
              <img
  src={`${API_URL}/uploads/team/${member.image}`}
  alt={member.name}
  className="teamPro-img"
/>
            </div>

            <div className="teamPro-info">
              <div>
                <h3 className="teamPro-name">{member.name}</h3>
                <p className="teamPro-role">{member.role}</p>
              </div>

              {/* {member.linkedin_url && (
                <a
                  href={member.linkedin_url}
                  target="_blank"
                  rel="noreferrer"
                  className="teamPro-linkedin"
                >
                  in
                </a>
              )} */}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
